// Exporta productos a CSV (abre en Excel/Sheets y sirve para imprimir
// etiquetas en lote desde Print Master, que importa Excel/CSV y genera
// los códigos de barras).

// Excel ejecuta como fórmula un texto que empieza con = + - @; se le antepone
// un apóstrofo (los números negativos se dejan igual).
const sinFormula = (s) => (/^[=+\-@\t\r]/.test(s) && !/^-?\d+([.,]\d+)?$/.test(s) ? `'${s}` : s);

const escapar = (v) => {
  const s = sinFormula(v == null ? '' : String(v));
  return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function productosACSV(productos) {
  const cabecera = ['Codigo', 'Nombre', 'Precio', 'Talla', 'Marca', 'Categoria', 'Stock'];
  const filas = productos.map((p) => [
    p.codigo, p.nombre, p.precio_venta, p.talla || '', p.marca || '', p.categoria || '', p.stock ?? '',
  ]);
  return [cabecera, ...filas].map((f) => f.map(escapar).join(',')).join('\r\n');
}

// Descarga un texto como archivo. El BOM ayuda a que Excel abra los acentos.
export function descargarArchivo(nombre, contenido, tipo = 'text/csv;charset=utf-8') {
  const blob = new Blob(['﻿' + contenido], { type: tipo });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function exportarEtiquetasCSV(productos) {
  descargarArchivo('etiquetas-inventario.csv', productosACSV(productos));
}

// Exportar listas a Excel (CSV) y a PDF (ventana de impresión del navegador),
// sin librerías externas. El CSV usa separador ';' y BOM para que Excel en
// español abra los acentos y las columnas bien de una vez.

function descargarBlob(blob, nombreArchivo) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Genera un .csv que Excel abre con doble clic (sin advertencias de formato).
export function descargarCSV(nombreArchivo, encabezados, filas) {
  const esc = (v) => {
    const s = sinFormula(String(v == null ? '' : v));
    return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const sep = ';';
  const lineas = [
    encabezados.map(esc).join(sep),
    ...filas.map((f) => f.map(esc).join(sep)),
  ];
  const contenido = '﻿' + lineas.join('\r\n'); // BOM UTF-8
  const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
  const nombre = nombreArchivo.endsWith('.csv') ? nombreArchivo : `${nombreArchivo}.csv`;
  descargarBlob(blob, nombre);
}

export function escaparHtml(v) {
  return String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Abre una ventana lista para imprimir → el usuario elige "Guardar como PDF".
// Diseño limpio y con la marca, pensado también para imprimir en papel.
export function imprimirPDF({ titulo, subtitulo, encabezados, filas, pie }) {
  const w = window.open('', '_blank');
  if (!w) {
    alert('Permití las ventanas emergentes en tu navegador para poder descargar el PDF.');
    return;
  }
  const ths = encabezados.map((h) => `<th>${escaparHtml(h)}</th>`).join('');
  const trs = filas
    .map((f) => `<tr>${f.map((c) => `<td>${escaparHtml(c)}</td>`).join('')}</tr>`)
    .join('');
  const st = 'script'; // evita cerrar el <script> del bundle desde el string
  const html = `<!doctype html><html lang="es"><head><meta charset="utf-8">
    <title>${escaparHtml(titulo)}</title>
    <style>
      * { box-sizing: border-box; }
      body { font-family: Arial, Helvetica, sans-serif; color: #1F2937; margin: 28px; }
      h1 { font-size: 20px; margin: 0 0 2px; color: #BE185D; }
      .sub { font-size: 13px; color: #6B7280; margin: 0 0 18px; }
      table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
      thead th { background: #FCE7F3; color: #9D174D; text-align: left; padding: 8px 10px; border-bottom: 2px solid #F9A8D4; }
      tbody td { padding: 7px 10px; border-bottom: 1px solid #F3F4F6; }
      tbody tr:nth-child(even) td { background: #FAFAFA; }
      .pie { margin-top: 16px; font-size: 12px; color: #6B7280; }
      .barra { margin: 0 0 18px; }
      button { background: #DB2777; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-size: 14px; font-weight: bold; cursor: pointer; }
      @media print { .barra { display: none; } body { margin: 0; } }
    </style></head><body>
    <div class="barra"><button onclick="window.print()">🖨️ Imprimir o guardar como PDF</button></div>
    <h1>${escaparHtml(titulo)}</h1>
    ${subtitulo ? `<p class="sub">${escaparHtml(subtitulo)}</p>` : ''}
    <table><thead><tr>${ths}</tr></thead><tbody>${trs}</tbody></table>
    ${pie ? `<p class="pie">${escaparHtml(pie)}</p>` : ''}
    <${st}>window.onload = function () { setTimeout(function () { window.print(); }, 350); };</${st}>
    </body></html>`;
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
}
